// The categorical palette from ENG-21740, the same one MAvatar assigns a person, reused to give a
// workspace a stable colour. Twenty slots, each pairing a background with a foreground chosen for
// contrast, so the pair is designed rather than computed.
//
// Deriving a colour from the tenant id itself was the obvious shortcut and is wrong: a tenant id
// is not always six hex characters (extractTenant in utils/route.ts also accepts sixteen), the
// resulting colour is arbitrary so it can collide with the app's status colours, and it ties the
// palette to an id format that may change.
export const CATEGORICAL_SLOT_COUNT = 20;

// Same hash as MAvatar.vue, so a given string lands on the same slot in both. Any string works,
// whatever its length or alphabet.
export function categoricalSlot(value: string): number | undefined {
  if (!value) return undefined;

  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }

  return Math.abs(hash) % CATEGORICAL_SLOT_COUNT;
}

export function categoricalSlotClass(value: string): string {
  const slot = categoricalSlot(value);

  return undefined === slot ? "" : `m-categorical-${slot}`;
}
